import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

interface InputMoneyProps {
    value: number;
    onChange: (value: number) => void;
    addonBefore?: string;
    label?: string;
}

const DECIMAL_SIZE = 2;

const formatCurrency = (value: number): string => {
    const [inteiro, decimal] = value.toFixed(DECIMAL_SIZE).split('.');
    
    const inteiroFormatado = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    return `R$ ${inteiroFormatado},${decimal}`;
};

const InputMoney = ({ value, onChange, addonBefore = 'R$', label, ...props }: InputMoneyProps) => {

    const [currentValue, setCurrentValue] = useState<string>('0,00');

    useEffect(() => {
        if (typeof value === 'number' && !isNaN(value)) {
            setCurrentValue(formatCurrency(value));
        }
    }, [value])

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputValue = e.target.value;
        
        const onlyNumbers = inputValue.replace(/\D/g, '');
        
        if (onlyNumbers === '') {
            setCurrentValue('0,00');
            onChange(0);
            return;
        }
        
        const numberValue = parseInt(onlyNumbers) / 100;
     
        const formattedValue = formatCurrency(numberValue);
   
        setCurrentValue(formattedValue);
        
        
        onChange(numberValue);
    }

    return (
        <div>
            <Form.Group className="mb-3">
                <Form.Label>{label}</Form.Label>
                <Form.Control
                    type="text"
                    value={currentValue}
                    onChange={handleOnChange}
                    placeholder="0,00"
                    {...props}
                />
            </Form.Group>
        </div>
    )
}

export default InputMoney;